import { IEventTemplateFilters } from '@/types/projects.types';
import { Get } from '../helpers';

const GetTemplateFilters = async ({
  channel,
}: {
  channel: number;
}): Promise<{ templateFilters: IEventTemplateFilters | null }> => {
  return Get({
    path: `/v3/admin/events/template-filters/${channel}`,
  });
};

export default GetTemplateFilters;
